import { BCNotification } from '@bimser/components';
import { RuleEngineEntities } from '@bimser/components/dist/BCRuleManager';
import { IDictionary, RxEventEmitter, MLHelper } from '@bimser/core';
import React from 'react';

export function showToasterMessage(
	title: IDictionary<string> | string,
	type: RuleEngineEntities.AlertType | 'Validation',
	message: IDictionary<string> | string | React.ReactNode,
	highlightList?: string[],
	windowId?: string,
	activeView?: string
) {
	const data = {
		message: MLHelper.getMLText(title),
		description: React.isValidElement(message) ? message : MLHelper.getMLText(message),
		highlightList: highlightList || []
	};

	switch (type) {
		case 'Error': {
			BCNotification.error(data);
			break;
		}
		case 'Info': {
			BCNotification.info(data);
			break;
		}
		case 'Success': {
			BCNotification.success(data);
			break;
		}
		case 'Warning': {
			BCNotification.warning(data);
			break;
		}
		case 'SevereWarning': {
			BCNotification.severeWarning(data);
			break;
		}
		case 'Blocked': {
			BCNotification.blocked(data);
			break;
		}
		case 'Validation': {
			if (highlightList?.length) {
				highlightList.forEach(controlName => {
					const subjectId = `highlight_${windowId}${controlName}${activeView}`;
					RxEventEmitter.emit(subjectId, {
						type: 'ACTIVATE_CONTROL_HIGHLIGHT',
						windowId: windowId,
						status: true,
						alertType: 'Warning',
						messages: data.description
					});
				});
			}
			BCNotification.warning({
				...data,
				autoClose: false
			});
			break;
		}
		default:
			console.warn('Action alert type not found');
	}
}
